import React, {Component} from "react";
import {connect} from "react-redux";

import {
    BgColorsOutlined,
    ControlOutlined,
    ExpandOutlined,
    FilterOutlined,
    MobileOutlined,
    ReloadOutlined,
    ShareAltOutlined,
    ToolOutlined,
    UserOutlined,
} from '@ant-design/icons';

import {Col, Icon, Row, Spin} from 'antd';
import cookie from 'react-cookies';
import "../asset/style/scanner/scanner.css";
import {reloadDeviceConfig} from "../utils/device_utils"
import { getStateAwareUrl } from "utils/utils";

class SettingsView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isBusy: false,
            deviceId: this.props.match.params.id,
        }
    }

    reloadSettings = () => {
        reloadDeviceConfig(this.state.deviceId,
            () => this.setState({isBusy: true}),
            () => this.setState({isBusy: false}),
            () => this.setState({isBusy: false})
        )
    }

    render() {

        let scanner_control = <Row>
            <Col span={12} offset={6}>
                <Row className="scanner-main-control-buttons">
                    <Col span={6}>
                        <a href={getStateAwareUrl("/stagecleaner/" + this.state.deviceId + "/")} className="scanner-user-controls">
	                        <Row><MobileOutlined className="scanner-main-control-icon"/></Row>
	                        <Row className="arial-font">Stage Maintenance</Row>
                        </a>
                    </Col>
                    <Col span={6}>
                        <a href={getStateAwareUrl("/objectivecleaner/" + this.state.deviceId + "/")} className="scanner-user-controls">
	                        <Row><FilterOutlined className="scanner-main-control-icon"/></Row>
	                        <Row className="arial-font">Objective Cleaning</Row>
                        </a>
                    </Col>

                </Row>
            </Col>
        </Row>;

        let admin_control = <Row>
            <Col span={12} offset={6}>
                <Row className="scanner-main-control-buttons">
                    <Col span={6}>
                        <a href={getStateAwareUrl("/server/devices/" + this.state.deviceId + "/settings/tune_intra_field/")} className="scanner-user-controls">
                            <Row><ToolOutlined className="scanner-main-control-icon" /></Row>
                            <Row className="arial-font">Tune Intrafield</Row>
                        </a>
                    </Col>
                    <Col span={6}>
                        <a href={getStateAwareUrl("/server/devices/" + this.state.deviceId + "/settings/tune_camera/")} className="scanner-user-controls">
                            <Row><BgColorsOutlined className="scanner-main-control-icon" /></Row>
                            <Row className="arial-font">Exposure &amp; White Balance</Row>
                        </a>
                    </Col>
                    <Col span={6}>
                        <a href={getStateAwareUrl("/server/devices/" + this.state.deviceId + "/settings/preview_tuning/")} className="scanner-user-controls">
                            <Row><ControlOutlined className="scanner-main-control-icon" /></Row>
                            <Row className="arial-font">Preview Tuning (1x3 slides)</Row>
                        </a>
                    </Col>
                    <Col span={6}>
                        <a href={getStateAwareUrl("/server/devices/" + this.state.deviceId + "/settings/mapping_fine_tune/")} className="scanner-user-controls">
                            <Row><ShareAltOutlined className="scanner-main-control-icon" /></Row>
                            <Row className="arial-font">Mapping Fine Tune (1x3 slides)</Row>
                        </a>
                    </Col>
                    <Col span={6} onClick={this.reloadSettings}>
                        <div className="scanner-user-controls">
                            <Row><ReloadOutlined className="scanner-main-control-icon" /></Row>
                            <Row className="arial-font">Reload Settings</Row>
                        </div>
                    </Col>
                    <Col span={6}>
                        <a href={getStateAwareUrl('/server/devices/' + this.state.deviceId + '/manualmode/')} className="scanner-user-controls">
                            <Row><Icon type="sliders" className="scanner-main-control-icon" /></Row>
                            <Row className="arial-font">Old Manual Mode</Row>
                        </a>
                    </Col>
                </Row>
                <Row className="scanner-main-control-buttons">
                    <Col span={6}>
                        <a href={getStateAwareUrl("/server/devices/" + this.state.deviceId + "/settings/preview_tuning_2by3/")} className="scanner-user-controls">
                            <Row><ControlOutlined className="scanner-main-control-icon" /></Row>
                            <Row className="arial-font">Preview Tuning (2x3 slides)</Row>
                        </a>
                    </Col>
                    <Col span={6}>
                        <a href={getStateAwareUrl("/server/devices/" + this.state.deviceId + "/settings/mapping_fine_tune_2by3/")} className="scanner-user-controls">
                            <Row><ShareAltOutlined className="scanner-main-control-icon" /></Row>
                            <Row className="arial-font">Mapping Fine Tune (2x3 slides)</Row>
                        </a>
                    </Col>
                </Row>
                <Row className="scanner-main-control-buttons">
                    <Col offset={6} span={6}>
	                    <a href={getStateAwareUrl("/videos/" + this.state.deviceId + "/")} className="scanner-user-controls">
		                    <Row><UserOutlined className="scanner-main-control-icon"/></Row>
		                    <Row className="arial-font">Helper Guide</Row>
	                    </a>
                    </Col>
                    <Col span={6}>
	                    <a href={getStateAwareUrl("/vignette_diagnostics/" + this.state.deviceId + "/")} className="scanner-user-controls">
		                    <Row><ExpandOutlined className="scanner-main-control-icon"/></Row>
		                    <Row className="arial-font">Scanner Calibration</Row>
	                    </a>
                    </Col>
                </Row>
            </Col>
        </Row>;


        return (
            <div>
                <Row className="rounded-container">
                    <Col className="scanner-name arial-font" span={24}>
                        <div className="device-name">
                            Settings
                        </div>
                    </Col>
                </Row>
                <Spin spinning={this.state.isBusy} size="large">
                    {cookie.loadAll().superuser === "true" ?
                        admin_control : null
                    }
                    {scanner_control}
                </Spin>
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        device: state.deviceStatusReducer[ownProps.match.params.id]
    };
};

export default connect(mapStateToProps)(SettingsView);
